import React from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';
import { useTextReplacement } from '../../../hooks/useTextReplacement';

/**
 * Loading spinner component with optional message
 * Uses semantic color classes from shared configuration
 */
const LoadingSpinner = ({ message = 'Loading...', className = '', size = 'md' }) => {
  const colors = useColors();
  const semantic = colors.semantic;
  const { replace } = useTextReplacement();

  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-10 w-10',
    lg: 'h-16 w-16'
  };

  return (
    <div className={`flex flex-col items-center justify-center p-4 ${className}`}>
      <div className={`animate-spin rounded-full border-b-2 ${semantic.loadingSpinnerActive} ${semantic.loadingSpinnerBorder} ${sizeClasses[size]} mb-2`}></div>
      {message && (
        <p className={`text-sm ${semantic.loadingText}`}>
          {replace(message)}
        </p>
      )}
    </div>
  );
};

LoadingSpinner.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};

export default LoadingSpinner;

